import PropTypes from "prop-types";
import * as React from "react";
import QuickActionTile from "../templates/quickActionTile";
import { SSE_INTERNAL_JOBS } from "../../../constants/externalUrls";
import SingleLinkTile from "../templates/singleLinkTile";
import { quickActionTilesMap } from "../tilesMap";

const CareersTile = ({ id }) => {
    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                link={SSE_INTERNAL_JOBS}
                title={"Careers"}
                linkText={quickActionTilesMap[id].description}
            />
        </QuickActionTile>
    );
};

CareersTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default CareersTile;
